import { __decorate, __extends } from "tslib";
import { ERR_INVALID_ARGUMENT } from "../../utils/error";
import { Log } from "../../utils/Log";
import { soapAttribute, SoapRequestData, SoapService, soapNodeText } from "../SoapService";
var AddStateCode = /** @class */ (function (_super) {
    __extends(AddStateCode, _super);
    function AddStateCode() {
        var _this = _super.call(this) || this;
        _this.value = "";
        _this.domain = "";
        return _this;
    }
    AddStateCode.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, AddStateCode.FromSoapNU));
    };
    AddStateCode.FromSoapNU = function (pSoapData) {
        var _a;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tCode = new AddStateCode();
        tCode.value = (_a = SoapService.GetSoapDataNodeValue(pSoapData)) !== null && _a !== void 0 ? _a : "";
        tCode.domain = pSoapData.domain;
        return (tCode);
    };
    __decorate([
        soapNodeText()
    ], AddStateCode.prototype, "value", void 0);
    __decorate([
        soapAttribute()
    ], AddStateCode.prototype, "domain", void 0);
    return AddStateCode;
}(SoapRequestData));
export { AddStateCode };
var ArticleDescription = /** @class */ (function (_super) {
    __extends(ArticleDescription, _super);
    function ArticleDescription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @internal */
    ArticleDescription.prototype._getPropertyValue = function (pProperty) {
        //handle extra shortText array wrapper
        if (pProperty === "shortText")
            return (this.shortText != null ? { text: this.shortText } : undefined);
        //handle extra longText array wrapper
        if (pProperty === "longText")
            return (this.longText != null ? { text: this.longText } : undefined);
        //handle extra featureText array wrapper
        if (pProperty === "featureText")
            return (this.featureText != null ? { text: this.featureText } : undefined);
        return (_super.prototype._getPropertyValue.call(this, pProperty));
    };
    ArticleDescription.FromSoap = function (pSoapData) {
        var _a, _b, _c;
        if (pSoapData == null)
            return (undefined);
        var tArtDesc = new ArticleDescription();
        //handle extra array wrappers
        tArtDesc.shortText = DisplayText.FromSoapArray((_a = pSoapData.shortText) === null || _a === void 0 ? void 0 : _a.text);
        tArtDesc.longText = DisplayText.FromSoapArray((_b = pSoapData.longText) === null || _b === void 0 ? void 0 : _b.text);
        tArtDesc.featureText = DisplayText.FromSoapArray((_c = pSoapData.featureText) === null || _c === void 0 ? void 0 : _c.text);
        return (tArtDesc);
    };
    return ArticleDescription;
}(SoapRequestData));
export { ArticleDescription };
var ArticleProperties = /** @class */ (function (_super) {
    __extends(ArticleProperties, _super);
    function ArticleProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArticleProperties.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, ArticleProperties.FromSoapNU));
    };
    ArticleProperties.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tArticleProps = new ArticleProperties();
        tArticleProps.catalogId = pSoapData.catalogId;
        tArticleProps.manufacturerId = pSoapData.manufacturerId;
        tArticleProps.manufacturerName = pSoapData.manufacturerName;
        tArticleProps.seriesId = pSoapData.seriesId;
        tArticleProps.seriesName = pSoapData.seriesName;
        tArticleProps.manufacturer = pSoapData.manufacturer;
        tArticleProps.program = pSoapData.program;
        tArticleProps.distributionRegion = pSoapData.distributionRegion;
        tArticleProps.baseArticleNumber = pSoapData.baseArticleNumber;
        tArticleProps.finalArticleNumber = pSoapData.finalArticleNumber;
        tArticleProps.variantCode = pSoapData.variantCode;
        tArticleProps.ofmlVariantCode = pSoapData.ofmlVariantCode;
        tArticleProps.useFinalArticleNumber = SoapService.SoapDataToBool(pSoapData.useFinalArticleNumber);
        tArticleProps.shortText = pSoapData.shortText;
        tArticleProps.longText = pSoapData.longText;
        tArticleProps.featureText = pSoapData.featureText;
        tArticleProps.descriptionMode = pSoapData.descriptionMode;
        tArticleProps.productDescription = ArticleDescription.FromSoap(pSoapData.productDescription);
        tArticleProps.userDescription = ArticleDescription.FromSoap(pSoapData.userDescription);
        tArticleProps.currency = pSoapData.currency;
        tArticleProps.purchaseCurrency = pSoapData.purchaseCurrency;
        tArticleProps.salesCurrency = pSoapData.salesCurrency;
        tArticleProps.purchasePrice = SoapService.SoapDataToFloat(pSoapData.purchasePrice);
        tArticleProps.salesPrice = SoapService.SoapDataToFloat(pSoapData.salesPrice);
        tArticleProps.priceDateSupported = SoapService.SoapDataToBool(pSoapData.priceDateSupported);
        tArticleProps.priceDateEditable = SoapService.SoapDataToBool(pSoapData.priceDateEditable);
        tArticleProps.priceDate = pSoapData.priceDate;
        tArticleProps.quantity = SoapService.SoapDataToFloat(pSoapData.quantity);
        tArticleProps.alternativePosition = SoapService.SoapDataToBool(pSoapData.alternativePosition);
        tArticleProps.excludedCalculations = SoapService.SoapDataToArray(pSoapData.excludedCalculations);
        tArticleProps.inconsistencyFlag = SoapService.SoapDataToBool(pSoapData.inconsistencyFlag);
        tArticleProps.inconsistencyReason = SoapService.SoapDataToArray(pSoapData.inconsistencyReason);
        tArticleProps.priceInfo = PriceInfo.FromSoap(pSoapData.priceInfo);
        tArticleProps.packagingInfo = PackagingInfo.FromSoap(pSoapData.packagingInfo);
        tArticleProps.ofmlUpdateState = pSoapData.ofmlUpdateState;
        tArticleProps.geometryId = pSoapData.geometryId;
        tArticleProps.subArticles = ArticleProperties.FromSoapArray(pSoapData.subArticles);
        tArticleProps.addStateCodes = AddStateCode.FromSoapArray(pSoapData.addStateCodes);
        return (tArticleProps);
    };
    ArticleProperties.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (ArticleProperties.FromSoap(pSoapData));
    };
    return ArticleProperties;
}(SoapRequestData));
export { ArticleProperties };
var BasketColumn = /** @class */ (function (_super) {
    __extends(BasketColumn, _super);
    function BasketColumn() {
        var _this = _super.call(this) || this;
        _this.id = "";
        return _this;
    }
    BasketColumn.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, BasketColumn.FromSoapNU));
    };
    BasketColumn.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tColumn = new BasketColumn();
        tColumn.name = pSoapData.name;
        tColumn.title = pSoapData.title;
        tColumn.defaultValue = pSoapData.defaultValue;
        tColumn.id = pSoapData.id;
        tColumn.type = pSoapData.type;
        tColumn.itemAttrId = pSoapData.itemAttrId;
        tColumn.removable = SoapService.SoapDataToBool(pSoapData.removable);
        tColumn.editable = SoapService.SoapDataToBool(pSoapData.editable);
        tColumn.defaultColumn = pSoapData.defaultColumn;
        tColumn.minWidth = SoapService.SoapDataToFloat(pSoapData.minWidth);
        tColumn.weight = SoapService.SoapDataToInt(pSoapData.weight);
        tColumn.readOnly = SoapService.SoapDataToBool(pSoapData.readOnly);
        return (tColumn);
    };
    BasketColumn.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (BasketColumn.FromSoap(pSoapData));
    };
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "id", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "type", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "itemAttrId", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "removable", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "editable", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "defaultColumn", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "minWidth", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "weight", void 0);
    __decorate([
        soapAttribute()
    ], BasketColumn.prototype, "readOnly", void 0);
    return BasketColumn;
}(SoapRequestData));
export { BasketColumn };
var BasketConfig = /** @class */ (function (_super) {
    __extends(BasketConfig, _super);
    function BasketConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasketConfig.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tConfig = new BasketConfig();
        tConfig.viewIds = SoapService.SoapDataToArray(pSoapData.viewIds);
        tConfig.columnIds = SoapService.SoapDataToArray(pSoapData.columnIds);
        tConfig.defaultView = pSoapData.defaultView;
        tConfig.columnsEditable = SoapService.SoapDataToBool(pSoapData.columnsEditable);
        tConfig.currency = pSoapData.currency;
        tConfig.currencyEditable = SoapService.SoapDataToBool(pSoapData.currencyEditable);
        tConfig.defaultPriceDate = pSoapData.defaultPriceDate;
        return (tConfig);
    };
    __decorate([
        soapAttribute()
    ], BasketConfig.prototype, "defaultView", void 0);
    __decorate([
        soapAttribute()
    ], BasketConfig.prototype, "columnsEditable", void 0);
    __decorate([
        soapAttribute()
    ], BasketConfig.prototype, "currency", void 0);
    __decorate([
        soapAttribute()
    ], BasketConfig.prototype, "currencyEditable", void 0);
    __decorate([
        soapAttribute()
    ], BasketConfig.prototype, "defaultPriceDate", void 0);
    return BasketConfig;
}(SoapRequestData));
export { BasketConfig };
var BasketViewConfig = /** @class */ (function (_super) {
    __extends(BasketViewConfig, _super);
    function BasketViewConfig() {
        var _this = _super.call(this) || this;
        _this.viewId = "";
        return _this;
    }
    BasketViewConfig.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, BasketViewConfig.FromSoapNU));
    };
    BasketViewConfig.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tConfig = new BasketViewConfig();
        tConfig.name = pSoapData.name;
        tConfig.visibleColumns = SoapService.SoapDataToArray(pSoapData.visibleColumns);
        tConfig.columnWidths = ColumnWidth.FromSoapArray(pSoapData.columnWidths);
        tConfig.sortConfig = BasketViewSortConfig.FromSoap(pSoapData.sortConfig);
        tConfig.articleDescrMode = SoapService.SoapDataToArray(pSoapData.articleDescrMode);
        tConfig.viewId = pSoapData.viewId;
        tConfig.removable = SoapService.SoapDataToBool(pSoapData.removable);
        tConfig.editable = SoapService.SoapDataToBool(pSoapData.editable);
        tConfig.displayMode = pSoapData.displayMode;
        tConfig.expandGroups = SoapService.SoapDataToBool(pSoapData.expandGroups);
        tConfig.expandPlanningFolders = SoapService.SoapDataToBool(pSoapData.expandPlanningFolders);
        tConfig.expandBasketFolders = SoapService.SoapDataToBool(pSoapData.expandBasketFolders);
        tConfig.expandPartialPlannings = SoapService.SoapDataToBool(pSoapData.expandPartialPlannings);
        tConfig.expandAggregates = SoapService.SoapDataToBool(pSoapData.expandAggregates);
        tConfig.mergeMode = pSoapData.mergeMode;
        tConfig.autoColumnWidth = SoapService.SoapDataToBool(pSoapData.autoColumnWidth);
        tConfig.hiddenDiscounts = SoapService.SoapDataToBool(pSoapData.hiddenDiscounts);
        tConfig.setArticleMode = pSoapData.setArticleMode;
        return (tConfig);
    };
    BasketViewConfig.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (BasketViewConfig.FromSoap(pSoapData));
    };
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "viewId", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "removable", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "editable", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "displayMode", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "expandGroups", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "expandPlanningFolders", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "expandBasketFolders", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "expandPartialPlannings", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "expandAggregates", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "mergeMode", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "autoColumnWidth", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "hiddenDiscounts", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewConfig.prototype, "setArticleMode", void 0);
    return BasketViewConfig;
}(SoapRequestData));
export { BasketViewConfig };
var BasketViewSortConfig = /** @class */ (function (_super) {
    __extends(BasketViewSortConfig, _super);
    function BasketViewSortConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @internal */
    BasketViewSortConfig.prototype._getPropertyValue = function (pProperty) {
        //handle extra groups array wrapper
        if (pProperty === "groups")
            return (this.groups != null ? { group: this.groups } : undefined);
        return (_super.prototype._getPropertyValue.call(this, pProperty));
    };
    BasketViewSortConfig.FromSoap = function (pSoapData) {
        var _a;
        if (pSoapData == null)
            return (undefined);
        var tConfig = new BasketViewSortConfig();
        tConfig.collatorStrength = pSoapData.collatorStrength;
        tConfig.collatorDecomposition = pSoapData.collatorDecomposition;
        //handle extra groups array wrapper
        tConfig.groups = SortGroup.FromSoapArray((_a = pSoapData.groups) === null || _a === void 0 ? void 0 : _a.group);
        return (tConfig);
    };
    __decorate([
        soapAttribute()
    ], BasketViewSortConfig.prototype, "collatorStrength", void 0);
    __decorate([
        soapAttribute()
    ], BasketViewSortConfig.prototype, "collatorDecomposition", void 0);
    return BasketViewSortConfig;
}(SoapRequestData));
export { BasketViewSortConfig };
var ColumnSortOrder = /** @class */ (function (_super) {
    __extends(ColumnSortOrder, _super);
    function ColumnSortOrder() {
        var _this = _super.call(this) || this;
        _this.columnId = "";
        return _this;
    }
    ColumnSortOrder.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, ColumnSortOrder.FromSoapNU));
    };
    ColumnSortOrder.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tOrder = new ColumnSortOrder();
        tOrder.columnId = pSoapData.columnId;
        tOrder.ascending = SoapService.SoapDataToBool(pSoapData.ascending);
        tOrder.undefinedFirst = SoapService.SoapDataToBool(pSoapData.undefinedFirst);
        return (tOrder);
    };
    __decorate([
        soapAttribute()
    ], ColumnSortOrder.prototype, "columnId", void 0);
    __decorate([
        soapAttribute()
    ], ColumnSortOrder.prototype, "ascending", void 0);
    __decorate([
        soapAttribute()
    ], ColumnSortOrder.prototype, "undefinedFirst", void 0);
    return ColumnSortOrder;
}(SoapRequestData));
export { ColumnSortOrder };
var ColumnWidth = /** @class */ (function (_super) {
    __extends(ColumnWidth, _super);
    function ColumnWidth() {
        var _this = _super.call(this) || this;
        _this.columnId = "";
        _this.width = 0;
        return _this;
    }
    ColumnWidth.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, ColumnWidth.FromSoapNU));
    };
    ColumnWidth.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tWidth = new ColumnWidth();
        tWidth.columnId = pSoapData.columnId;
        tWidth.width = SoapService.SoapDataToInt(pSoapData.value);
        return (tWidth);
    };
    __decorate([
        soapAttribute()
    ], ColumnWidth.prototype, "columnId", void 0);
    __decorate([
        soapAttribute()
    ], ColumnWidth.prototype, "width", void 0);
    return ColumnWidth;
}(SoapRequestData));
export { ColumnWidth };
var ComposableGeometryProperties = /** @class */ (function (_super) {
    __extends(ComposableGeometryProperties, _super);
    function ComposableGeometryProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComposableGeometryProperties.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, ComposableGeometryProperties.FromSoapNU));
    };
    ComposableGeometryProperties.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tGeomProps = new ComposableGeometryProperties();
        tGeomProps.enabled = SoapService.SoapDataToBool(pSoapData.enabled);
        tGeomProps.position = Vector3.FromSoap(pSoapData.position);
        tGeomProps.rotation = Rotation.FromSoap(pSoapData.rotation);
        tGeomProps.scale = Vector3.FromSoap(pSoapData.scale);
        tGeomProps.geometry = pSoapData.geometry;
        tGeomProps.itemId = pSoapData.itemId;
        return (tGeomProps);
    };
    ComposableGeometryProperties.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (ComposableGeometryProperties.FromSoap(pSoapData));
    };
    __decorate([
        soapAttribute()
    ], ComposableGeometryProperties.prototype, "itemId", void 0);
    return ComposableGeometryProperties;
}(SoapRequestData));
export { ComposableGeometryProperties };
var CopyOptions = /** @class */ (function (_super) {
    __extends(CopyOptions, _super);
    function CopyOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], CopyOptions.prototype, "encoding", void 0);
    __decorate([
        soapAttribute()
    ], CopyOptions.prototype, "suffix", void 0);
    __decorate([
        soapAttribute()
    ], CopyOptions.prototype, "overwrite", void 0);
    __decorate([
        soapAttribute()
    ], CopyOptions.prototype, "cut", void 0);
    return CopyOptions;
}(SoapRequestData));
export { CopyOptions };
var DisplayText = /** @class */ (function (_super) {
    __extends(DisplayText, _super);
    function DisplayText() {
        var _this = _super.call(this) || this;
        _this.value = "";
        return _this;
    }
    DisplayText.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, DisplayText.FromSoapNU));
    };
    DisplayText.FromSoapNU = function (pSoapData) {
        var _a;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tName = new DisplayText();
        tName.value = (_a = SoapService.GetSoapDataNodeValue(pSoapData)) !== null && _a !== void 0 ? _a : "";
        tName.lang = pSoapData.lang;
        return (tName);
    };
    __decorate([
        soapNodeText()
    ], DisplayText.prototype, "value", void 0);
    __decorate([
        soapAttribute()
    ], DisplayText.prototype, "lang", void 0);
    return DisplayText;
}(SoapRequestData));
export { DisplayText };
var ExchangeRate = /** @class */ (function (_super) {
    __extends(ExchangeRate, _super);
    function ExchangeRate() {
        var _this = _super.call(this) || this;
        _this.currency = "";
        _this.rate = 0;
        return _this;
    }
    ExchangeRate.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ExchangeRate.FromSoapNU));
    };
    ExchangeRate.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tRate = new ExchangeRate();
        tRate.currency = pSoapData.currency;
        tRate.rate = SoapService.SoapDataToFloat(pSoapData.rate);
        return (tRate);
    };
    __decorate([
        soapAttribute()
    ], ExchangeRate.prototype, "currency", void 0);
    __decorate([
        soapAttribute()
    ], ExchangeRate.prototype, "rate", void 0);
    return ExchangeRate;
}(SoapRequestData));
export { ExchangeRate };
var FolderProperties = /** @class */ (function (_super) {
    __extends(FolderProperties, _super);
    function FolderProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @internal */
    FolderProperties.prototype._getPropertyValue = function (pProperty) {
        //handle extra displayName array wrapper
        if (pProperty === "displayName")
            return (this.displayName != null ? { text: this.displayName } : undefined);
        return (_super.prototype._getPropertyValue.call(this, pProperty));
    };
    FolderProperties.FromSoap = function (pSoapData) {
        var _a;
        if (pSoapData == null)
            return (undefined);
        var tFolderProps = new FolderProperties();
        tFolderProps.name = pSoapData.name;
        tFolderProps.showSubTotal = SoapService.SoapDataToBool(pSoapData.showSubTotal);
        //handle extra displayName array wrapper
        tFolderProps.displayName = DisplayText.FromSoapArray((_a = pSoapData.displayName) === null || _a === void 0 ? void 0 : _a.text);
        return (tFolderProps);
    };
    return FolderProperties;
}(SoapRequestData));
export { FolderProperties };
var GetArticleDataOptions = /** @class */ (function (_super) {
    __extends(GetArticleDataOptions, _super);
    function GetArticleDataOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetArticleDataOptions.prototype, "separateCurrencies", void 0);
    return GetArticleDataOptions;
}(SoapRequestData));
export { GetArticleDataOptions };
var GetArticleFeaturesOptions = /** @class */ (function (_super) {
    __extends(GetArticleFeaturesOptions, _super);
    function GetArticleFeaturesOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GetArticleFeaturesOptions;
}(SoapRequestData));
export { GetArticleFeaturesOptions };
var GetChoiceListOptions = /** @class */ (function (_super) {
    __extends(GetChoiceListOptions, _super);
    function GetChoiceListOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetChoiceListOptions.prototype, "convertSurcharge", void 0);
    __decorate([
        soapAttribute()
    ], GetChoiceListOptions.prototype, "formatSurcharge", void 0);
    __decorate([
        soapAttribute()
    ], GetChoiceListOptions.prototype, "discardSurcharge", void 0);
    return GetChoiceListOptions;
}(SoapRequestData));
export { GetChoiceListOptions };
var InsertArticleOptions = /** @class */ (function (_super) {
    __extends(InsertArticleOptions, _super);
    function InsertArticleOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InsertArticleOptions;
}(SoapRequestData));
export { InsertArticleOptions };
var InsertInfo = /** @class */ (function (_super) {
    __extends(InsertInfo, _super);
    function InsertInfo() {
        var _this = _super.call(this) || this;
        _this.baseArticleNumber = "";
        return _this;
    }
    return InsertInfo;
}(SoapRequestData));
export { InsertInfo };
var ItemProperties = /** @class */ (function (_super) {
    __extends(ItemProperties, _super);
    function ItemProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemProperties.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ItemProperties.FromSoapNU));
    };
    ItemProperties.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tItemProps = new ItemProperties();
        tItemProps.itemId = pSoapData.itemId;
        tItemProps.itemType = pSoapData.itemType;
        tItemProps.visible = SoapService.SoapDataToBool(pSoapData.visible);
        tItemProps.expanded = SoapService.SoapDataToBool(pSoapData.expanded);
        tItemProps.label = pSoapData.label;
        tItemProps.setArticleId = pSoapData.setArticleId;
        tItemProps.tmRows = TMRow.FromSoapArray(pSoapData.tmRows);
        tItemProps.tmDescription = pSoapData.tmDescription;
        tItemProps.composableGeometry = ComposableGeometryProperties.FromSoap(pSoapData.composableGeometry);
        tItemProps.composableGeometries = ComposableGeometryProperties.FromSoapArray(pSoapData.composableGeometries);
        tItemProps.folder = FolderProperties.FromSoap(pSoapData.folder);
        tItemProps.article = ArticleProperties.FromSoap(pSoapData.article);
        tItemProps.setArticle = SetArticleProperties.FromSoap(pSoapData.setArticle);
        tItemProps.textItem = TextItemProperties.FromSoap(pSoapData.textItem);
        tItemProps.positionNumber = pSoapData.positionNumber;
        return (tItemProps);
    };
    __decorate([
        soapAttribute()
    ], ItemProperties.prototype, "positionNumber", void 0);
    return ItemProperties;
}(SoapRequestData));
export { ItemProperties };
var ItemSelectionOptions = /** @class */ (function (_super) {
    __extends(ItemSelectionOptions, _super);
    function ItemSelectionOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], ItemSelectionOptions.prototype, "wholeComposite", void 0);
    __decorate([
        soapAttribute()
    ], ItemSelectionOptions.prototype, "subItems", void 0);
    __decorate([
        soapAttribute()
    ], ItemSelectionOptions.prototype, "parentItems", void 0);
    __decorate([
        soapAttribute()
    ], ItemSelectionOptions.prototype, "viewId", void 0);
    return ItemSelectionOptions;
}(SoapRequestData));
export { ItemSelectionOptions };
var DeleteItemsOptions = /** @class */ (function (_super) {
    __extends(DeleteItemsOptions, _super);
    function DeleteItemsOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], DeleteItemsOptions.prototype, "subArticles", void 0);
    return DeleteItemsOptions;
}(ItemSelectionOptions));
export { DeleteItemsOptions };
var GetAllItemsOptions = /** @class */ (function (_super) {
    __extends(GetAllItemsOptions, _super);
    function GetAllItemsOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetAllItemsOptions.prototype, "setArticleIds", void 0);
    __decorate([
        soapAttribute()
    ], GetAllItemsOptions.prototype, "geometryIds", void 0);
    __decorate([
        soapAttribute()
    ], GetAllItemsOptions.prototype, "positionNumbers", void 0);
    __decorate([
        soapAttribute()
    ], GetAllItemsOptions.prototype, "basketItems", void 0);
    return GetAllItemsOptions;
}(ItemSelectionOptions));
export { GetAllItemsOptions };
var GetImagesOptions = /** @class */ (function (_super) {
    __extends(GetImagesOptions, _super);
    function GetImagesOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetImagesOptions.prototype, "useCache", void 0);
    __decorate([
        soapAttribute()
    ], GetImagesOptions.prototype, "generate", void 0);
    __decorate([
        soapAttribute()
    ], GetImagesOptions.prototype, "itemIds", void 0);
    __decorate([
        soapAttribute()
    ], GetImagesOptions.prototype, "attributes", void 0);
    return GetImagesOptions;
}(ItemSelectionOptions));
export { GetImagesOptions };
var GetItemFieldsOptions = /** @class */ (function (_super) {
    __extends(GetItemFieldsOptions, _super);
    function GetItemFieldsOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetItemFieldsOptions.prototype, "useDefault", void 0);
    __decorate([
        soapAttribute()
    ], GetItemFieldsOptions.prototype, "expandVariables", void 0);
    __decorate([
        soapAttribute()
    ], GetItemFieldsOptions.prototype, "resolveURI", void 0);
    __decorate([
        soapAttribute()
    ], GetItemFieldsOptions.prototype, "useImageCache", void 0);
    __decorate([
        soapAttribute()
    ], GetItemFieldsOptions.prototype, "generateImages", void 0);
    return GetItemFieldsOptions;
}(ItemSelectionOptions));
export { GetItemFieldsOptions };
var GetItemPropertiesOptions = /** @class */ (function (_super) {
    __extends(GetItemPropertiesOptions, _super);
    function GetItemPropertiesOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "priceInfo", void 0);
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "pricingProcedureName", void 0);
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "positionNumbers", void 0);
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "addStateCodes", void 0);
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "textMode", void 0);
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "preferUserDescriptions", void 0);
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "separateCurrencies", void 0);
    __decorate([
        soapAttribute()
    ], GetItemPropertiesOptions.prototype, "includeCalculationErrorsInInconsistencies", void 0);
    return GetItemPropertiesOptions;
}(ItemSelectionOptions));
export { GetItemPropertiesOptions };
var GetManufacturerInfoOptions = /** @class */ (function (_super) {
    __extends(GetManufacturerInfoOptions, _super);
    function GetManufacturerInfoOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "allData", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "allLanguages", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "manufacturerName", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "seriesInfo", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "seriesName", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "manufacturerConfig", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "distributorName", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "copyright", void 0);
    __decorate([
        soapAttribute()
    ], GetManufacturerInfoOptions.prototype, "address", void 0);
    return GetManufacturerInfoOptions;
}(ItemSelectionOptions));
export { GetManufacturerInfoOptions };
var GetPriceCalculationSheetOptions = /** @class */ (function (_super) {
    __extends(GetPriceCalculationSheetOptions, _super);
    function GetPriceCalculationSheetOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], GetPriceCalculationSheetOptions.prototype, "sumUpComposite", void 0);
    __decorate([
        soapAttribute()
    ], GetPriceCalculationSheetOptions.prototype, "itemCondAmountPerUnit", void 0);
    __decorate([
        soapAttribute()
    ], GetPriceCalculationSheetOptions.prototype, "headerCondAmountPerUnit", void 0);
    __decorate([
        soapAttribute()
    ], GetPriceCalculationSheetOptions.prototype, "excludeInactiveItems", void 0);
    __decorate([
        soapAttribute()
    ], GetPriceCalculationSheetOptions.prototype, "includeInactiveItems", void 0);
    return GetPriceCalculationSheetOptions;
}(ItemSelectionOptions));
export { GetPriceCalculationSheetOptions };
var ItemField = /** @class */ (function (_super) {
    __extends(ItemField, _super);
    function ItemField() {
        var _this = _super.call(this) || this;
        _this.data = "";
        _this.itemId = "";
        _this.columnId = "";
        return _this;
    }
    ItemField.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ItemField.FromSoapNU));
    };
    ItemField.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tField = new ItemField();
        tField.data = pSoapData.data;
        tField.itemId = pSoapData.itemId;
        tField.columnId = pSoapData.columnId;
        return (tField);
    };
    __decorate([
        soapAttribute()
    ], ItemField.prototype, "itemId", void 0);
    __decorate([
        soapAttribute()
    ], ItemField.prototype, "columnId", void 0);
    return ItemField;
}(SoapRequestData));
export { ItemField };
var UpdateBasketArticlesOptions = /** @class */ (function (_super) {
    __extends(UpdateBasketArticlesOptions, _super);
    function UpdateBasketArticlesOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], UpdateBasketArticlesOptions.prototype, "update", void 0);
    __decorate([
        soapAttribute()
    ], UpdateBasketArticlesOptions.prototype, "migrate", void 0);
    __decorate([
        soapAttribute()
    ], UpdateBasketArticlesOptions.prototype, "recalculate", void 0);
    __decorate([
        soapAttribute()
    ], UpdateBasketArticlesOptions.prototype, "priceDate", void 0);
    return UpdateBasketArticlesOptions;
}(ItemSelectionOptions));
export { UpdateBasketArticlesOptions };
var OAPActionContext = /** @class */ (function (_super) {
    __extends(OAPActionContext, _super);
    function OAPActionContext() {
        var _this = _super.call(this) || this;
        _this.self = "";
        return _this;
    }
    __decorate([
        soapAttribute()
    ], OAPActionContext.prototype, "self", void 0);
    __decorate([
        soapAttribute()
    ], OAPActionContext.prototype, "interactor", void 0);
    __decorate([
        soapAttribute()
    ], OAPActionContext.prototype, "dpr", void 0);
    return OAPActionContext;
}(SoapRequestData));
export { OAPActionContext };
var OperationMode = /** @class */ (function (_super) {
    __extends(OperationMode, _super);
    function OperationMode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], OperationMode.prototype, "subPositions", void 0);
    __decorate([
        soapAttribute()
    ], OperationMode.prototype, "mainArticles", void 0);
    __decorate([
        soapAttribute()
    ], OperationMode.prototype, "breakUpSetArticles", void 0);
    __decorate([
        soapAttribute()
    ], OperationMode.prototype, "migrate", void 0);
    return OperationMode;
}(SoapRequestData));
export { OperationMode };
var PackagingInfo = /** @class */ (function (_super) {
    __extends(PackagingInfo, _super);
    function PackagingInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PackagingInfo.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tPackInfo = new PackagingInfo();
        tPackInfo.width = Quantity.FromSoap(pSoapData.width);
        tPackInfo.height = Quantity.FromSoap(pSoapData.height);
        tPackInfo.depth = Quantity.FromSoap(pSoapData.depth);
        tPackInfo.volume = Quantity.FromSoap(pSoapData.volume);
        tPackInfo.tareWeight = Quantity.FromSoap(pSoapData.tareWeight);
        tPackInfo.netWeight = Quantity.FromSoap(pSoapData.netWeight);
        tPackInfo.itemsPerPackUnit = SoapService.SoapDataToInt(pSoapData.itemsPerPackUnit);
        tPackInfo.packUnitsPerArticle = SoapService.SoapDataToInt(pSoapData.packUnitsPerArticle);
        return (tPackInfo);
    };
    return PackagingInfo;
}(SoapRequestData));
export { PackagingInfo };
var RelocateItemsOptions = /** @class */ (function (_super) {
    __extends(RelocateItemsOptions, _super);
    function RelocateItemsOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], RelocateItemsOptions.prototype, "doNotModify", void 0);
    __decorate([
        soapAttribute()
    ], RelocateItemsOptions.prototype, "flat", void 0);
    return RelocateItemsOptions;
}(SoapRequestData));
export { RelocateItemsOptions };
var PasteOptions = /** @class */ (function (_super) {
    __extends(PasteOptions, _super);
    function PasteOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], PasteOptions.prototype, "reuseItemIds", void 0);
    __decorate([
        soapAttribute()
    ], PasteOptions.prototype, "returnOriginalItemIds", void 0);
    __decorate([
        soapAttribute()
    ], PasteOptions.prototype, "ignoreComposableGeometries", void 0);
    return PasteOptions;
}(SoapRequestData));
export { PasteOptions };
var PasteContainerOptions = /** @class */ (function (_super) {
    __extends(PasteContainerOptions, _super);
    function PasteContainerOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        soapAttribute()
    ], PasteContainerOptions.prototype, "setArticleIds", void 0);
    __decorate([
        soapAttribute()
    ], PasteContainerOptions.prototype, "geometryIds", void 0);
    return PasteContainerOptions;
}(PasteOptions));
export { PasteContainerOptions };
var Rotation = /** @class */ (function (_super) {
    __extends(Rotation, _super);
    function Rotation() {
        var _this = _super.call(this) || this;
        _this.angle = 0;
        return _this;
    }
    Rotation.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tRot = new Rotation();
        tRot.axis = Vector3.FromSoapNU(pSoapData.axis);
        tRot.angle = SoapService.SoapDataToFloat(pSoapData.angle);
        return (tRot);
    };
    __decorate([
        soapAttribute()
    ], Rotation.prototype, "angle", void 0);
    return Rotation;
}(SoapRequestData));
export { Rotation };
var SetArticleProperties = /** @class */ (function (_super) {
    __extends(SetArticleProperties, _super);
    function SetArticleProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetArticleProperties.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tSetProps = new SetArticleProperties();
        tSetProps.partIds = SoapService.SoapDataToArray(pSoapData.partIds);
        tSetProps.allPartIds = SoapService.SoapDataToArray(pSoapData.allPartIds);
        tSetProps.collapsed = SoapService.SoapDataToBool(pSoapData.collapsed);
        return (tSetProps);
    };
    __decorate([
        soapAttribute()
    ], SetArticleProperties.prototype, "collapsed", void 0);
    return SetArticleProperties;
}(SoapRequestData));
export { SetArticleProperties };
var SortGroup = /** @class */ (function (_super) {
    __extends(SortGroup, _super);
    function SortGroup() {
        var _this = _super.call(this) || this;
        _this.position = 0;
        return _this;
    }
    SortGroup.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, SortGroup.FromSoapNU));
    };
    SortGroup.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tGroup = new SortGroup();
        tGroup.selector = SortGroupSelector.FromSoapArray(pSoapData.selector);
        tGroup.sortOrder = ColumnSortOrder.FromSoapArray(pSoapData.sortOrder);
        tGroup.position = SoapService.SoapDataToInt(pSoapData.position);
        return (tGroup);
    };
    __decorate([
        soapAttribute()
    ], SortGroup.prototype, "position", void 0);
    return SortGroup;
}(SoapRequestData));
export { SortGroup };
var SortGroupSelector = /** @class */ (function (_super) {
    __extends(SortGroupSelector, _super);
    function SortGroupSelector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortGroupSelector.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, SortGroupSelector.FromSoapNU));
    };
    SortGroupSelector.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tSelector = new SortGroupSelector();
        tSelector.itemType = pSoapData.itemType;
        tSelector.itemId = pSoapData.itemId;
        return (tSelector);
    };
    __decorate([
        soapAttribute()
    ], SortGroupSelector.prototype, "itemType", void 0);
    __decorate([
        soapAttribute()
    ], SortGroupSelector.prototype, "itemId", void 0);
    return SortGroupSelector;
}(SoapRequestData));
export { SortGroupSelector };
var TextItemProperties = /** @class */ (function (_super) {
    __extends(TextItemProperties, _super);
    function TextItemProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @internal */
    TextItemProperties.prototype._getPropertyValue = function (pProperty) {
        //handle extra displayText array wrapper
        if (pProperty === "displayText")
            return (this.displayText != null ? { text: this.displayText } : undefined);
        return (_super.prototype._getPropertyValue.call(this, pProperty));
    };
    TextItemProperties.FromSoap = function (pSoapData) {
        var _a;
        if (pSoapData == null)
            return (undefined);
        var tTextProps = new TextItemProperties();
        tTextProps.text = pSoapData.text;
        //handle extra displayText array wrapper
        tTextProps.displayText = DisplayText.FromSoapArray((_a = pSoapData.displayText) === null || _a === void 0 ? void 0 : _a.text);
        return (tTextProps);
    };
    return TextItemProperties;
}(SoapRequestData));
export { TextItemProperties };
var Vector3 = /** @class */ (function (_super) {
    __extends(Vector3, _super);
    function Vector3() {
        var _this = _super.call(this) || this;
        _this.x = 0;
        _this.y = 0;
        _this.z = 0;
        return _this;
    }
    Vector3.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tVector = new Vector3();
        tVector.x = SoapService.SoapDataToFloat(pSoapData.x);
        tVector.y = SoapService.SoapDataToFloat(pSoapData.y);
        tVector.z = SoapService.SoapDataToFloat(pSoapData.z);
        return (tVector);
    };
    Vector3.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (Vector3.FromSoap(pSoapData));
    };
    __decorate([
        soapAttribute()
    ], Vector3.prototype, "x", void 0);
    __decorate([
        soapAttribute()
    ], Vector3.prototype, "y", void 0);
    __decorate([
        soapAttribute()
    ], Vector3.prototype, "z", void 0);
    return Vector3;
}(SoapRequestData));
export { Vector3 };
var Value = /** @class */ (function (_super) {
    __extends(Value, _super);
    function Value() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Value.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tXsiType = pSoapData["xsi:type"];
        if (tXsiType == null)
            tXsiType = "";
        var tValue = undefined;
        if (tXsiType.indexOf("Quantity") > -1) {
            var tQuantity = new Quantity();
            tQuantity.unit = pSoapData.unit;
            tValue = tQuantity;
        }
        else if (tXsiType.indexOf("Money") > -1) {
            var tMoney = new Money();
            tMoney.currency = pSoapData.currency;
            tValue = tMoney;
        }
        else if (tXsiType.indexOf("Percentage") > -1) {
            tValue = new Percentage();
        }
        else {
            tValue = new Value();
        }
        tValue.value = SoapService.SoapDataToFloat(pSoapData.value);
        return (tValue);
    };
    __decorate([
        soapAttribute()
    ], Value.prototype, "value", void 0);
    return Value;
}(SoapRequestData));
export { Value };
var Money = /** @class */ (function (_super) {
    __extends(Money, _super);
    function Money() {
        var _this = _super.call(this) || this;
        _this.currency = "";
        return _this;
    }
    Money.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tMoney = new Money();
        tMoney.currency = pSoapData.currency;
        tMoney.value = SoapService.SoapDataToFloat(pSoapData.value);
        return (tMoney);
    };
    __decorate([
        soapAttribute()
    ], Money.prototype, "currency", void 0);
    return Money;
}(Value));
export { Money };
var Percentage = /** @class */ (function (_super) {
    __extends(Percentage, _super);
    function Percentage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Percentage;
}(Value));
export { Percentage };
var Quantity = /** @class */ (function (_super) {
    __extends(Quantity, _super);
    function Quantity() {
        var _this = _super.call(this) || this;
        _this.unit = "";
        return _this;
    }
    Quantity.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tQuantity = new Quantity();
        tQuantity.unit = pSoapData.unit;
        tQuantity.value = SoapService.SoapDataToFloat(pSoapData.value);
        return (tQuantity);
    };
    __decorate([
        soapAttribute()
    ], Quantity.prototype, "unit", void 0);
    return Quantity;
}(Value));
export { Quantity };
////////
// response types
var ArticleData = /** @class */ (function () {
    function ArticleData() {
    }
    ArticleData.prototype.getProperty = function (pPropClass, pPropName) {
        if (this.properties == null)
            return (null);
        for (var i = 0; i < this.properties.length; ++i) {
            if (this.properties[i].propClass === pPropClass &&
                this.properties[i].propName === pPropName) {
                return (this.properties[i]);
            }
        }
        return (null);
    };
    ArticleData.prototype.getPropertyValue = function (pPropClass, pPropName) {
        var tProperty = this.getProperty(pPropClass, pPropName);
        if (tProperty != null)
            return (tProperty.value);
        else
            return (null);
    };
    ArticleData.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tData = new ArticleData();
        tData.baseArticleNumber = pSoapData.baseArticleNumber;
        tData.catalogIcon = pSoapData.catalogIcon;
        tData.catalogImage = pSoapData.catalogImage;
        tData.currency = pSoapData.currency;
        tData.descriptionMode = pSoapData.descriptionMode;
        tData.featureText = pSoapData.featureText;
        tData.longText = pSoapData.longText;
        tData.manufacturerId = pSoapData.manufacturerId;
        tData.seriesId = pSoapData.seriesId;
        tData.shortText = pSoapData.shortText;
        tData.variantCode = pSoapData.variantCode;
        tData.pdPurchasePrice = SoapService.SoapDataToFloat(pSoapData.pdPurchasePrice);
        tData.pdPurchasePriceComponents = PriceComponent.FromSoapArray(pSoapData.pdPurchasePriceComponents);
        tData.pdSalesPrice = SoapService.SoapDataToFloat(pSoapData.pdSalesPrice);
        tData.pdSalesPriceComponents = PriceComponent.FromSoapArray(pSoapData.pdSalesPriceComponents);
        tData.properties = Property.FromSoapArray(pSoapData.properties);
        tData.propertyClasses = PropertyClass.FromSoapArray(pSoapData.propertyClasses);
        tData.purchaseCurrency = pSoapData.purchaseCurrency;
        tData.salesCurrency = pSoapData.salesCurrency;
        tData.priceDateSupported = SoapService.SoapDataToBool(pSoapData.priceDateSupported);
        tData.priceDateEditable = SoapService.SoapDataToBool(pSoapData.priceDateEditable);
        tData.priceDate = pSoapData.priceDate;
        return (tData);
    };
    return ArticleData;
}());
export { ArticleData };
var ArticleFeature = /** @class */ (function () {
    function ArticleFeature() {
    }
    ArticleFeature.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ArticleFeature.FromSoapNU));
    };
    ArticleFeature.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tFeature = new ArticleFeature();
        tFeature.displayName = pSoapData.displayName;
        tFeature.displayValue = pSoapData.displayValue;
        tFeature.symbolicName = pSoapData.symbolicName;
        tFeature.symbolicValue = pSoapData.symbolicValue;
        tFeature.visible = SoapService.SoapDataToBool(pSoapData.visible);
        return (tFeature);
    };
    return ArticleFeature;
}());
export { ArticleFeature };
var BasketItem = /** @class */ (function () {
    function BasketItem() {
    }
    /**
     * Returns this.mainArticleId if it is a valid id or this.itemId otherwise.
     * Returns undefined if this.mainArticleId is undefined.
     */
    BasketItem.prototype.getMainArticleId = function () {
        if (this.mainArticleId == null)
            return (undefined);
        if (this.mainArticleId === "" || this.mainArticleId === "00000000-0000-0000-0000-000000000000") {
            return (this.itemId);
        }
        else {
            return (this.mainArticleId);
        }
    };
    BasketItem.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, BasketItem.FromSoapNU));
    };
    BasketItem.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, BasketItem.FromSoapNU));
    };
    BasketItem.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tItem = new BasketItem();
        tItem.itemId = pSoapData.itemId;
        tItem.itemType = pSoapData.itemType;
        tItem.label = pSoapData.label;
        tItem.mainArticleId = pSoapData.mainArticleId;
        tItem.subArticleIds = SoapService.SoapDataToArray(pSoapData.subArticleIds);
        tItem.subItemIds = SoapService.SoapDataToArray(pSoapData.subItemIds);
        tItem.setArticlePartIds = SoapService.SoapDataToArray(pSoapData.setArticlePartIds);
        tItem.basketItemIds = SoapService.SoapDataToArray(pSoapData.basketItemIds);
        tItem.basketItems = BasketItem.FromSoapArray(pSoapData.basketItems);
        tItem.setArticleId = pSoapData.setArticleId;
        tItem.geometryId = pSoapData.geometryId;
        tItem.positionNumber = pSoapData.positionNumber;
        return (tItem);
    };
    return BasketItem;
}());
export { BasketItem };
var BasketServiceFault = /** @class */ (function () {
    function BasketServiceFault() {
    }
    BasketServiceFault.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tFault = new BasketServiceFault();
        tFault.message = pSoapData.message;
        tFault.partCompositionFailures = PartCompositionFailure.FromSoapArray(pSoapData.partCompositionFailures);
        return (tFault);
    };
    return BasketServiceFault;
}());
export { BasketServiceFault };
var CalculationLine = /** @class */ (function () {
    function CalculationLine() {
    }
    CalculationLine.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, CalculationLine.FromSoapNU));
    };
    CalculationLine.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tLine = new CalculationLine();
        tLine.inactive = SoapService.SoapDataToArray(pSoapData.inactive);
        tLine.description = pSoapData.description;
        tLine.amount = Value.FromSoap(pSoapData.amount);
        tLine.qtyRelation = Quantity.FromSoap(pSoapData.qtyRelation);
        tLine.value = Money.FromSoap(pSoapData.value);
        tLine.groupError = CSValidationError.FromSoap(pSoapData.groupError);
        tLine.error = CSValidationError.FromSoap(pSoapData.error);
        tLine.level = SoapService.SoapDataToInt(pSoapData.level);
        tLine.counter = SoapService.SoapDataToInt(pSoapData.counter);
        tLine.conditionType = pSoapData.conditionType;
        tLine.conditionRemovable = SoapService.SoapDataToBool(pSoapData.conditionRemovable);
        tLine.amountEditable = SoapService.SoapDataToBool(pSoapData.amountEditable);
        tLine.amountEdited = SoapService.SoapDataToBool(pSoapData.amountEdited);
        tLine.qtyRelationEditable = SoapService.SoapDataToBool(pSoapData.qtyRelationEditable);
        tLine.valueEditable = SoapService.SoapDataToBool(pSoapData.valueEditable);
        return (tLine);
    };
    return CalculationLine;
}());
export { CalculationLine };
var CalculationSheet = /** @class */ (function () {
    function CalculationSheet() {
    }
    CalculationSheet.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tSheet = new CalculationSheet();
        tSheet.quantity = Quantity.FromSoap(pSoapData.quantity);
        tSheet.netValue = Money.FromSoap(pSoapData.netValue);
        tSheet.tax = Money.FromSoap(pSoapData.tax);
        tSheet.lines = CalculationLine.FromSoapArrayNU(pSoapData.lines);
        tSheet.addableConditions = SoapService.SoapDataToArrayNU(pSoapData.addableConditions);
        tSheet.currency = pSoapData.currency;
        return (tSheet);
    };
    return CalculationSheet;
}());
export { CalculationSheet };
var ChoiceList = /** @class */ (function () {
    function ChoiceList() {
    }
    ChoiceList.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ChoiceList.FromSoapNU));
    };
    ChoiceList.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tChoiceList = new ChoiceList();
        tChoiceList.propClass = pSoapData.propClass;
        tChoiceList.propName = pSoapData.propName;
        tChoiceList.values = PropertyValue.FromSoapArrayNU(pSoapData.values);
        return (tChoiceList);
    };
    return ChoiceList;
}());
export { ChoiceList };
var ConditionType = /** @class */ (function () {
    function ConditionType() {
    }
    ConditionType.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ConditionType.FromSoapNU));
    };
    ConditionType.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tType = new ConditionType();
        tType.description = pSoapData.description;
        tType.accessMethod = pSoapData.accessMethod;
        tType.amountEditable = SoapService.SoapDataToBool(pSoapData.amountEditable);
        tType.calculationRule = pSoapData.calculationRule;
        tType.calculationRuleEditable = SoapService.SoapDataToBool(pSoapData.calculationRuleEditable);
        tType.conditionClass = pSoapData.conditionClass;
        tType.conditionDeletable = SoapService.SoapDataToBool(pSoapData.conditionDeletable);
        tType.conditionSign = pSoapData.conditionSign;
        tType.deferredCurrencyConversionEnabled = SoapService.SoapDataToBool(pSoapData.deferredCurrencyConversionEnabled);
        tType.editMode = pSoapData.editMode;
        tType.groupCondition = SoapService.SoapDataToBool(pSoapData.groupCondition);
        tType.headerCondition = SoapService.SoapDataToBool(pSoapData.headerCondition);
        tType.name = pSoapData.name;
        tType.quantityRelationEditable = SoapService.SoapDataToBool(pSoapData.quantityRelationEditable);
        tType.roundingRule = pSoapData.roundingRule;
        tType.valueEditable = SoapService.SoapDataToBool(pSoapData.valueEditable);
        return (tType);
    };
    return ConditionType;
}());
export { ConditionType };
var CSValidationError = /** @class */ (function () {
    function CSValidationError() {
    }
    CSValidationError.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tXsiType = pSoapData["xsi:type"];
        if (tXsiType == null)
            tXsiType = "";
        var tError = undefined;
        if (tXsiType.indexOf("CSArithmeticOperationError") > -1) {
            var tExtendedError = new CSArithmeticOperationError();
            tExtendedError.operationKind = pSoapData.operationKind;
            tError = tExtendedError;
        }
        else if (tXsiType.indexOf("CSConformabilityError") > -1) {
            var tExtendedError = new CSConformabilityError();
            tExtendedError.operationKind = pSoapData.operationKind;
            tExtendedError.unit1 = pSoapData.unit1;
            tExtendedError.unit2 = pSoapData.unit2;
            tError = tExtendedError;
        }
        else if (tXsiType.indexOf("CSCurrencyError") > -1) {
            var tExtendedError = new CSCurrencyError();
            tExtendedError.operationKind = pSoapData.operationKind;
            tExtendedError.currency1 = pSoapData.currency1;
            tExtendedError.currency2 = pSoapData.currency2;
            tError = tExtendedError;
        }
        else if (tXsiType.indexOf("CSInvalidValueError") > -1) {
            var tExtendedError = new CSInvalidValueError();
            tExtendedError.parameterKind = pSoapData.parameterKind;
            tError = tExtendedError;
        }
        else if (tXsiType.indexOf("CSItemDataAccessError") > -1) {
            tError = new CSItemDataAccessError();
        }
        else if (tXsiType.indexOf("CSLineNotFoundError") > -1) {
            tError = new CSLineNotFoundError();
        }
        else if (tXsiType.indexOf("CSUndefinedOperationError") > -1) {
            var tExtendedError = new CSUndefinedOperationError();
            tExtendedError.calculationRule = pSoapData.calculationRule;
            tError = tExtendedError;
        }
        else {
            tError = new CSValidationError();
        }
        tError.message = pSoapData.message;
        tError.resultKind = pSoapData.resultKind;
        tError.errorCode = pSoapData.errorCode;
        return (tError);
    };
    CSValidationError.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (OAPAction.FromSoap(pSoapData));
    };
    return CSValidationError;
}());
export { CSValidationError };
var CSArithmeticOperationError = /** @class */ (function (_super) {
    __extends(CSArithmeticOperationError, _super);
    function CSArithmeticOperationError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CSArithmeticOperationError;
}(CSValidationError));
export { CSArithmeticOperationError };
var CSConformabilityError = /** @class */ (function (_super) {
    __extends(CSConformabilityError, _super);
    function CSConformabilityError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CSConformabilityError;
}(CSValidationError));
export { CSConformabilityError };
var CSCurrencyError = /** @class */ (function (_super) {
    __extends(CSCurrencyError, _super);
    function CSCurrencyError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CSCurrencyError;
}(CSValidationError));
export { CSCurrencyError };
var CSInvalidValueError = /** @class */ (function (_super) {
    __extends(CSInvalidValueError, _super);
    function CSInvalidValueError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CSInvalidValueError;
}(CSValidationError));
export { CSInvalidValueError };
var CSItemDataAccessError = /** @class */ (function (_super) {
    __extends(CSItemDataAccessError, _super);
    function CSItemDataAccessError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CSItemDataAccessError;
}(CSValidationError));
export { CSItemDataAccessError };
var CSLineNotFoundError = /** @class */ (function (_super) {
    __extends(CSLineNotFoundError, _super);
    function CSLineNotFoundError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CSLineNotFoundError;
}(CSValidationError));
export { CSLineNotFoundError };
var CSUndefinedOperationError = /** @class */ (function (_super) {
    __extends(CSUndefinedOperationError, _super);
    function CSUndefinedOperationError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CSUndefinedOperationError;
}(CSValidationError));
export { CSUndefinedOperationError };
var ImageInfo = /** @class */ (function () {
    function ImageInfo() {
    }
    ImageInfo.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ImageInfo.FromSoapNU));
    };
    ImageInfo.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tInfo = new ImageInfo();
        tInfo.tag = pSoapData.tag;
        tInfo.url = pSoapData.url;
        tInfo.attributes = SoapService.SoapDataToArray(pSoapData.attributes);
        tInfo.itemId = pSoapData.itemId;
        return (tInfo);
    };
    return ImageInfo;
}());
export { ImageInfo };
var Interval = /** @class */ (function () {
    function Interval() {
    }
    Interval.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, Interval.FromSoapNU));
    };
    Interval.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tInterval = new Interval();
        tInterval.maxValue = SoapService.SoapDataToFloat(pSoapData.maxValue);
        tInterval.minValue = SoapService.SoapDataToFloat(pSoapData.minValue);
        return (tInterval);
    };
    return Interval;
}());
export { Interval };
var ItemCalculationSheet = /** @class */ (function () {
    function ItemCalculationSheet() {
    }
    ItemCalculationSheet.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ItemCalculationSheet.FromSoapNU));
    };
    ItemCalculationSheet.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tSheet = new ItemCalculationSheet();
        tSheet.id = pSoapData.id;
        tSheet.sheet = CalculationSheet.FromSoapNU(pSoapData.sheet);
        return (tSheet);
    };
    return ItemCalculationSheet;
}());
export { ItemCalculationSheet };
var ManufacturerInfo = /** @class */ (function () {
    function ManufacturerInfo() {
    }
    ManufacturerInfo.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ManufacturerInfo.FromSoapNU));
    };
    ManufacturerInfo.FromSoapNU = function (pSoapData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tInfo = new ManufacturerInfo();
        tInfo.manufacturerId = pSoapData.manufacturerId;
        tInfo.concernId = pSoapData.concernId;
        tInfo.supplierId = pSoapData.supplierId;
        tInfo.priceProfileRegionId = pSoapData.priceProfileRegionId;
        //handle extra array wrappers
        tInfo.manufacturerName = DisplayText.FromSoapArray((_a = pSoapData.manufacturerName) === null || _a === void 0 ? void 0 : _a.text);
        tInfo.seriesInfos = SeriesInfo.FromSoapArray((_b = pSoapData.seriesInfos) === null || _b === void 0 ? void 0 : _b.seriesInfo);
        tInfo.distributorName = DisplayText.FromSoapArray((_c = pSoapData.distributorName) === null || _c === void 0 ? void 0 : _c.text);
        tInfo.copyright = DisplayText.FromSoapArray((_d = pSoapData.copyright) === null || _d === void 0 ? void 0 : _d.text);
        tInfo.addressName = DisplayText.FromSoapArray((_e = pSoapData.addressName) === null || _e === void 0 ? void 0 : _e.text);
        tInfo.addressStreet = DisplayText.FromSoapArray((_f = pSoapData.addressStreet) === null || _f === void 0 ? void 0 : _f.text);
        tInfo.addressCity = DisplayText.FromSoapArray((_g = pSoapData.addressCity) === null || _g === void 0 ? void 0 : _g.text);
        tInfo.addressState = DisplayText.FromSoapArray((_h = pSoapData.addressState) === null || _h === void 0 ? void 0 : _h.text);
        tInfo.addressPOBox = DisplayText.FromSoapArray((_j = pSoapData.addressPOBox) === null || _j === void 0 ? void 0 : _j.text);
        tInfo.addressZIP = DisplayText.FromSoapArray((_k = pSoapData.addressZIP) === null || _k === void 0 ? void 0 : _k.text);
        tInfo.addressCountry = DisplayText.FromSoapArray((_l = pSoapData.addressCountry) === null || _l === void 0 ? void 0 : _l.text);
        tInfo.addressEMail = DisplayText.FromSoapArray((_m = pSoapData.addressEMail) === null || _m === void 0 ? void 0 : _m.text);
        tInfo.addressPhone = DisplayText.FromSoapArray((_o = pSoapData.addressPhone) === null || _o === void 0 ? void 0 : _o.text);
        tInfo.addressFAX = DisplayText.FromSoapArray((_p = pSoapData.addressFAX) === null || _p === void 0 ? void 0 : _p.text);
        tInfo.addressWWW = DisplayText.FromSoapArray((_q = pSoapData.addressWWW) === null || _q === void 0 ? void 0 : _q.text);
        return (tInfo);
    };
    return ManufacturerInfo;
}());
export { ManufacturerInfo };
var MergeResult = /** @class */ (function () {
    function MergeResult() {
    }
    MergeResult.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tResult = new MergeResult();
        tResult.addedItems = SoapService.SoapDataToArray(pSoapData.addedItems);
        tResult.removedItems = SoapService.SoapDataToArray(pSoapData.removedItems);
        tResult.movedItems = SoapService.SoapDataToArray(pSoapData.movedItems);
        tResult.updatedItems = SoapService.SoapDataToArray(pSoapData.updatedItems);
        return (tResult);
    };
    return MergeResult;
}());
export { MergeResult };
var OAPAction = /** @class */ (function () {
    function OAPAction() {
    }
    OAPAction.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tXsiType = pSoapData["xsi:type"];
        if (tXsiType == null)
            tXsiType = "";
        var tAction = undefined;
        if (tXsiType.indexOf("OAPActionChoiceAction") > -1) {
            var tActionChoice = new OAPActionChoiceAction();
            tActionChoice.title = pSoapData.title;
            tActionChoice.actions = OAPActionListItem.FromSoapArrayNU(pSoapData.actions);
            tActionChoice.viewType = pSoapData.viewType;
            tActionChoice.tileSize = pSoapData.tileSize;
            tAction = tActionChoice;
        }
        else if (tXsiType.indexOf("OAPPropChangeAction") > -1) {
            var tPropChange = new OAPPropChangeAction();
            tPropChange.type = pSoapData.type;
            tPropChange.property = pSoapData.property;
            tPropChange.value = pSoapData.value;
            tAction = tPropChange;
        }
        else if (tXsiType.indexOf("OAPPropEditAction") > -1) {
            var tPropEdit = new OAPPropEditAction();
            tPropEdit.title = pSoapData.title;
            tPropEdit.properties = SoapService.SoapDataToArray(pSoapData.properties);
            tPropEdit.propertyClasses = SoapService.SoapDataToArray(pSoapData.propertyClasses);
            tPropEdit.visibleOnly = SoapService.SoapDataToBool(pSoapData.visibleOnly);
            tPropEdit.editableOnly = SoapService.SoapDataToBool(pSoapData.editableOnly);
            tAction = tPropEdit;
        }
        else if (tXsiType.indexOf("OAPPropEdit2Action") > -1) {
            var tPropEdit2 = new OAPPropEdit2Action();
            tPropEdit2.title = pSoapData.title;
            tPropEdit2.properties = OAPPropEditProp.FromSoapArray(pSoapData.properties);
            tPropEdit2.propertyClasses = OAPPropEditClass.FromSoapArray(pSoapData.propertyClasses);
            tAction = tPropEdit2;
        }
        else if (tXsiType.indexOf("OAPCreateObjectAction") > -1) {
            var tCreate = new OAPCreateObjectAction();
            tCreate.parent = OAPObjectDefinition.FromSoap(pSoapData.parent);
            tCreate.ofmlVariantCode = pSoapData.ofmlVariantCode;
            tCreate.initialPlacement = OAPPlacement.FromSoap(pSoapData.initialPlacement);
            tCreate.articleSpecMode = pSoapData.articleSpecMode;
            tCreate.packageId = pSoapData.packageId;
            tCreate.baseArticleNumber = pSoapData.baseArticleNumber;
            tAction = tCreate;
        }
        else if (tXsiType.indexOf("OAPMethodCallAction") > -1) {
            var tMethod = new OAPMethodCallAction();
            tMethod.type = pSoapData.type;
            tMethod.context = pSoapData.context;
            tMethod.method = pSoapData.method;
            tMethod.arguments = pSoapData.arguments;
            tAction = tMethod;
        }
        else if (tXsiType.indexOf("OAPDeleteObjectAction") > -1) {
            tAction = new OAPDeleteObjectAction();
        }
        else if (tXsiType.indexOf("OAPSelectObjectAction") > -1) {
            tAction = new OAPSelectObjectAction();
        }
        else if (tXsiType.indexOf("OAPShowMediaAction") > -1) {
            var tShowMedia = new OAPShowMediaAction();
            tShowMedia.mediaSource = pSoapData.mediaSource;
            tShowMedia.mediaId = pSoapData.mediaId;
            tAction = tShowMedia;
        }
        else if (tXsiType.indexOf("OAPDimChangeAction") > -1) {
            var tDimChange = new OAPDimChangeAction();
            tDimChange.dimChanges = OAPDimChange.FromSoapArray(pSoapData.dimChanges);
            tAction = tDimChange;
        }
        else if (tXsiType.indexOf("OAPDimChange2Action") > -1) {
            var tDimChange2 = new OAPDimChange2Action();
            tDimChange2.dimChanges = OAPDimChange.FromSoapArray(pSoapData.dimChanges);
            tAction = tDimChange2;
        }
        else {
            Log.warn("Unknown OAPAction type: " + tXsiType);
            tAction = new OAPAction();
        }
        tAction.objects = OAPObjectDefinition.FromSoapArray(pSoapData.objects);
        tAction.id = pSoapData.id;
        return (tAction);
    };
    OAPAction.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (OAPAction.FromSoap(pSoapData));
    };
    return OAPAction;
}());
export { OAPAction };
var OAPActionChoiceAction = /** @class */ (function (_super) {
    __extends(OAPActionChoiceAction, _super);
    function OAPActionChoiceAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPActionChoiceAction;
}(OAPAction));
export { OAPActionChoiceAction };
var OAPCreateObjectAction = /** @class */ (function (_super) {
    __extends(OAPCreateObjectAction, _super);
    function OAPCreateObjectAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPCreateObjectAction;
}(OAPAction));
export { OAPCreateObjectAction };
var OAPDeleteObjectAction = /** @class */ (function (_super) {
    __extends(OAPDeleteObjectAction, _super);
    function OAPDeleteObjectAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPDeleteObjectAction;
}(OAPAction));
export { OAPDeleteObjectAction };
var OAPDimChangeAction = /** @class */ (function (_super) {
    __extends(OAPDimChangeAction, _super);
    function OAPDimChangeAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPDimChangeAction;
}(OAPAction));
export { OAPDimChangeAction };
var OAPDimChange2Action = /** @class */ (function (_super) {
    __extends(OAPDimChange2Action, _super);
    function OAPDimChange2Action() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPDimChange2Action;
}(OAPAction));
export { OAPDimChange2Action };
var OAPMethodCallAction = /** @class */ (function (_super) {
    __extends(OAPMethodCallAction, _super);
    function OAPMethodCallAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPMethodCallAction;
}(OAPAction));
export { OAPMethodCallAction };
var OAPPropChangeAction = /** @class */ (function (_super) {
    __extends(OAPPropChangeAction, _super);
    function OAPPropChangeAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPPropChangeAction;
}(OAPAction));
export { OAPPropChangeAction };
var OAPPropEditAction = /** @class */ (function (_super) {
    __extends(OAPPropEditAction, _super);
    function OAPPropEditAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPPropEditAction;
}(OAPAction));
export { OAPPropEditAction };
var OAPPropEdit2Action = /** @class */ (function (_super) {
    __extends(OAPPropEdit2Action, _super);
    function OAPPropEdit2Action() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPPropEdit2Action;
}(OAPAction));
export { OAPPropEdit2Action };
var OAPSelectObjectAction = /** @class */ (function (_super) {
    __extends(OAPSelectObjectAction, _super);
    function OAPSelectObjectAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPSelectObjectAction;
}(OAPAction));
export { OAPSelectObjectAction };
var OAPShowMediaAction = /** @class */ (function (_super) {
    __extends(OAPShowMediaAction, _super);
    function OAPShowMediaAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPShowMediaAction;
}(OAPAction));
export { OAPShowMediaAction };
var OAPActionResult = /** @class */ (function () {
    function OAPActionResult() {
    }
    OAPActionResult.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, OAPActionResult.FromSoapNU));
    };
    OAPActionResult.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, OAPActionResult.FromSoapNU));
    };
    OAPActionResult.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tResult = new OAPActionResult();
        tResult.actionData = OAPAction.FromSoap(pSoapData.actionData);
        tResult.objects = SoapService.SoapDataToArray(pSoapData.objects);
        tResult.referenceObject = pSoapData.referenceObject;
        tResult.newObjectPosition = Vector3.FromSoap(pSoapData.newObjectPosition);
        tResult.newObjectRotation = Rotation.FromSoap(pSoapData.newObjectRotation);
        tResult.addedItems = SoapService.SoapDataToArray(pSoapData.addedItems);
        tResult.removedItems = SoapService.SoapDataToArray(pSoapData.removedItems);
        tResult.movedItems = SoapService.SoapDataToArray(pSoapData.movedItems);
        tResult.updatedItems = SoapService.SoapDataToArray(pSoapData.updatedItems);
        tResult.id = pSoapData.id;
        tResult.state = pSoapData.state;
        return (tResult);
    };
    return OAPActionResult;
}());
export { OAPActionResult };
var OAPActionListItem = /** @class */ (function () {
    function OAPActionListItem() {
    }
    OAPActionListItem.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, OAPActionListItem.FromSoapNU));
    };
    OAPActionListItem.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tItem = new OAPActionListItem();
        tItem.action = OAPAction.FromSoap(pSoapData.action);
        tItem.actionIds = SoapService.SoapDataToArray(pSoapData.actionIds);
        tItem.text = pSoapData.text;
        tItem.imageFile = pSoapData.imageFile;
        return (tItem);
    };
    return OAPActionListItem;
}());
export { OAPActionListItem };
var OAPDimChange = /** @class */ (function () {
    function OAPDimChange() {
    }
    OAPDimChange.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, OAPDimChange.FromSoapNU));
    };
    OAPDimChange.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tDimChange = new OAPDimChange();
        tDimChange.propChoiceList = SoapService.SoapDataToArray(pSoapData.propChoiceList, SoapService.SoapDataToFloat);
        tDimChange.axis = pSoapData.axis;
        tDimChange.dimension = pSoapData.dimension;
        tDimChange.propClass = pSoapData.propClass;
        tDimChange.propName = pSoapData.propName;
        tDimChange.propValue = SoapService.SoapDataToFloat(pSoapData.propValue);
        tDimChange.minPropValue = SoapService.SoapDataToFloat(pSoapData.minPropValue);
        tDimChange.maxPropValue = SoapService.SoapDataToFloat(pSoapData.maxPropValue);
        tDimChange.fixedValue = SoapService.SoapDataToBool(pSoapData.fixedValue);
        tDimChange.propDecDigits = SoapService.SoapDataToFloat(pSoapData.propDecDigits);
        tDimChange.multiplier = SoapService.SoapDataToFloat(pSoapData.multiplier);
        tDimChange.precision = SoapService.SoapDataToFloat(pSoapData.precision);
        tDimChange.changeSeparately = SoapService.SoapDataToBool(pSoapData.changeSeparately);
        tDimChange.thirdDimension = SoapService.SoapDataToBool(pSoapData.thirdDimension);
        return (tDimChange);
    };
    return OAPDimChange;
}());
export { OAPDimChange };
var OAPInteractor = /** @class */ (function () {
    function OAPInteractor() {
    }
    OAPInteractor.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, OAPInteractor.FromSoapNU));
    };
    OAPInteractor.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tInteractor = new OAPInteractor();
        tInteractor.symbolOffset = Vector3.FromSoap(pSoapData.symbolOffset);
        tInteractor.actionIds = SoapService.SoapDataToArray(pSoapData.actionIds);
        tInteractor.symbols = OAPSymbolDisplay.FromSoapArray(pSoapData.symbols);
        tInteractor.directActionIds = SoapService.SoapDataToArray(pSoapData.directActionIds);
        tInteractor.directActions = OAPActionResult.FromSoapArray(pSoapData.directActions);
        tInteractor.id = pSoapData.id;
        tInteractor.symbolType = pSoapData.symbolType;
        tInteractor.symbolSize = pSoapData.symbolSize;
        return (tInteractor);
    };
    return OAPInteractor;
}());
export { OAPInteractor };
var OAPObjectDefinition = /** @class */ (function () {
    function OAPObjectDefinition() {
    }
    OAPObjectDefinition.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, OAPObjectDefinition.FromSoapNU));
    };
    OAPObjectDefinition.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tDef = new OAPObjectDefinition();
        tDef.arguments = SoapService.SoapDataToArray(pSoapData.arguments);
        tDef.category = pSoapData.category;
        return (tDef);
    };
    OAPObjectDefinition.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        return (OAPObjectDefinition.FromSoap(pSoapData));
    };
    return OAPObjectDefinition;
}());
export { OAPObjectDefinition };
var OAPPropEditClass = /** @class */ (function () {
    function OAPPropEditClass() {
    }
    OAPPropEditClass.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, OAPPropEditClass.FromSoapNU));
    };
    OAPPropEditClass.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tClass = new OAPPropEditClass();
        tClass.propClass = pSoapData.propClass;
        tClass.visibleOnly = SoapService.SoapDataToBool(pSoapData.visibleOnly);
        tClass.editableOnly = SoapService.SoapDataToBool(pSoapData.editableOnly);
        return (tClass);
    };
    return OAPPropEditClass;
}());
export { OAPPropEditClass };
var OAPPropEditProp = /** @class */ (function () {
    function OAPPropEditProp() {
    }
    OAPPropEditProp.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, OAPPropEditProp.FromSoapNU));
    };
    OAPPropEditProp.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tProp = new OAPPropEditProp();
        tProp.propClass = pSoapData.propClass;
        tProp.propName = pSoapData.propName;
        tProp.visibleOnly = SoapService.SoapDataToBool(pSoapData.visibleOnly);
        tProp.editableOnly = SoapService.SoapDataToBool(pSoapData.editableOnly);
        return (tProp);
    };
    return OAPPropEditProp;
}());
export { OAPPropEditProp };
var OAPSymbolDisplay = /** @class */ (function () {
    function OAPSymbolDisplay() {
    }
    OAPSymbolDisplay.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, OAPSymbolDisplay.FromSoapNU));
    };
    OAPSymbolDisplay.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tSymbol = new OAPSymbolDisplay();
        tSymbol.symbolOffset = Vector3.FromSoap(pSoapData.symbolOffset);
        tSymbol.direction = Vector3.FromSoap(pSoapData.direction);
        tSymbol.orientationX = Vector3.FromSoap(pSoapData.orientationX);
        tSymbol.viewAngle = SoapService.SoapDataToFloat(pSoapData.viewAngle);
        tSymbol.hiddenMode = SoapService.SoapDataToBool(pSoapData.hiddenMode);
        return (tSymbol);
    };
    return OAPSymbolDisplay;
}());
export { OAPSymbolDisplay };
var OAPPlacement = /** @class */ (function () {
    function OAPPlacement() {
    }
    OAPPlacement.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tXsiType = pSoapData["xsi:type"];
        if (tXsiType == null)
            tXsiType = "";
        var tPlacement = undefined;
        if (tXsiType.indexOf("OAPDataDefinedPlacement") > -1) {
            var tAppPlacement = new OAPDataDefinedPlacement();
            tAppPlacement.referenceObject = OAPObjectDefinition.FromSoap(pSoapData.referenceObject);
            tAppPlacement.attachPoint = pSoapData.attachPoint;
            tPlacement = tAppPlacement;
        }
        else if (tXsiType.indexOf("OAPAttachAreasPlacement") > -1) {
            var tAttachPlacement = new OAPAttachAreasPlacement();
            tAttachPlacement.referenceObject = OAPObjectDefinition.FromSoapNU(pSoapData.referenceObject);
            tAttachPlacement.refObjectAttachAreaIds = SoapService.SoapDataToArrayNU(pSoapData.refObjectAttachAreaIds);
            tAttachPlacement.newObjectAttachAreaId = pSoapData.newObjectAttachAreaId;
            tPlacement = tAttachPlacement;
        }
        else {
            Log.warn("Unknown OAPPlacement type: " + tXsiType);
            tPlacement = new OAPPlacement();
        }
        return (tPlacement);
    };
    return OAPPlacement;
}());
export { OAPPlacement };
var OAPDataDefinedPlacement = /** @class */ (function (_super) {
    __extends(OAPDataDefinedPlacement, _super);
    function OAPDataDefinedPlacement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPDataDefinedPlacement;
}(OAPPlacement));
export { OAPDataDefinedPlacement };
var OAPAttachAreasPlacement = /** @class */ (function (_super) {
    __extends(OAPAttachAreasPlacement, _super);
    function OAPAttachAreasPlacement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OAPAttachAreasPlacement;
}(OAPPlacement));
export { OAPAttachAreasPlacement };
var OrderedTax = /** @class */ (function () {
    function OrderedTax() {
    }
    OrderedTax.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, OrderedTax.FromSoapNU));
    };
    OrderedTax.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tTax = new OrderedTax();
        tTax.order = SoapService.SoapDataToInt(pSoapData.order);
        tTax.typeId = pSoapData.typeId;
        return (tTax);
    };
    return OrderedTax;
}());
export { OrderedTax };
var PartCompositionFailure = /** @class */ (function () {
    function PartCompositionFailure() {
    }
    PartCompositionFailure.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, PartCompositionFailure.FromSoapNU));
    };
    PartCompositionFailure.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tFailure = new PartCompositionFailure();
        tFailure.itemId = pSoapData.itemId;
        tFailure.cause = SoapService.SoapDataToArray(pSoapData.cause);
        return (tFailure);
    };
    return PartCompositionFailure;
}());
export { PartCompositionFailure };
var PasteContainerResult = /** @class */ (function () {
    function PasteContainerResult() {
    }
    PasteContainerResult.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tResult = new PasteContainerResult();
        tResult.items = BasketItem.FromSoapArrayNU(pSoapData.items);
        tResult.itemGeometries = SoapService.SoapDataToArrayNU(pSoapData.itemGeometries);
        tResult.originalItemIds = SoapService.SoapDataToArray(pSoapData.originalItemIds);
        tResult.sceneGeometry = pSoapData.sceneGeometry;
        return (tResult);
    };
    return PasteContainerResult;
}());
export { PasteContainerResult };
var PriceInfo = /** @class */ (function () {
    function PriceInfo() {
    }
    PriceInfo.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tInfo = new PriceInfo();
        tInfo.unitSize = Quantity.FromSoap(pSoapData.unitSize);
        tInfo.netPrice = Money.FromSoap(pSoapData.netPrice);
        tInfo.netValue = Money.FromSoap(pSoapData.netValue);
        tInfo.tax = Money.FromSoap(pSoapData.tax);
        tInfo.extraPriceInfos = PriceInfoElement.FromSoapArray(pSoapData.extraPriceInfos);
        tInfo.inactive = SoapService.SoapDataToBool(pSoapData.inactive);
        tInfo.quantity = SoapService.SoapDataToFloat(pSoapData.quantity);
        return (tInfo);
    };
    return PriceInfo;
}());
export { PriceInfo };
var PriceInfoElement = /** @class */ (function () {
    function PriceInfoElement() {
    }
    PriceInfoElement.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, PriceInfoElement.FromSoapNU));
    };
    PriceInfoElement.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var pElement = new PriceInfoElement();
        pElement.value = Value.FromSoap(pSoapData.value);
        pElement.selector = pSoapData.selector;
        return (pElement);
    };
    return PriceInfoElement;
}());
export { PriceInfoElement };
var PriceComponent = /** @class */ (function () {
    function PriceComponent() {
    }
    PriceComponent.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, PriceComponent.FromSoapNU));
    };
    PriceComponent.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tComponent = new PriceComponent();
        tComponent.name = pSoapData.name;
        tComponent.value = SoapService.SoapDataToFloat(pSoapData.value);
        return (tComponent);
    };
    return PriceComponent;
}());
export { PriceComponent };
var PricingProcedure = /** @class */ (function () {
    function PricingProcedure() {
    }
    PricingProcedure.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tProc = new PricingProcedure();
        tProc.displayName = pSoapData.displayName;
        tProc.lines = PricingProcedureLine.FromSoapArrayNU(pSoapData.lines);
        tProc.halfWayRoundingMode = pSoapData.halfWayRoundingMode;
        tProc.name = pSoapData.name;
        return (tProc);
    };
    return PricingProcedure;
}());
export { PricingProcedure };
var PricingProcedureDescription = /** @class */ (function () {
    function PricingProcedureDescription() {
    }
    PricingProcedureDescription.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, PricingProcedureDescription.FromSoapNU));
    };
    PricingProcedureDescription.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tDesc = new PricingProcedureDescription();
        tDesc.displayName = pSoapData.displayName;
        tDesc.name = pSoapData.name;
        return (tDesc);
    };
    return PricingProcedureDescription;
}());
export { PricingProcedureDescription };
var PricingProcedureLine = /** @class */ (function () {
    function PricingProcedureLine() {
    }
    PricingProcedureLine.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, PricingProcedureLine.FromSoapNU));
    };
    PricingProcedureLine.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tLine = new PricingProcedureLine();
        tLine.description = pSoapData.description;
        tLine.tags = SoapService.SoapDataToArray(pSoapData.tags);
        tLine.conditionType = pSoapData.conditionType;
        tLine.counter = SoapService.SoapDataToInt(pSoapData.counter);
        tLine.from = SoapService.SoapDataToInt(pSoapData.from);
        tLine.insertMode = pSoapData.insertMode;
        tLine.level = SoapService.SoapDataToInt(pSoapData.level);
        tLine.lineType = pSoapData.lineType;
        tLine.maxOccurs = SoapService.SoapDataToInt(pSoapData.maxOccurs);
        tLine.printControl = pSoapData.printControl;
        tLine.to = SoapService.SoapDataToInt(pSoapData.to);
        return (tLine);
    };
    return PricingProcedureLine;
}());
export { PricingProcedureLine };
var Property = /** @class */ (function () {
    function Property() {
    }
    Property.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, Property.FromSoapNU));
    };
    Property.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tProperty = new Property();
        tProperty.addValues = SoapService.SoapDataToBool(pSoapData.addValues);
        tProperty.choiceList = SoapService.SoapDataToBool(pSoapData.choiceList);
        tProperty.decDigits = SoapService.SoapDataToInt(pSoapData.decDigits);
        tProperty.digits = SoapService.SoapDataToInt(pSoapData.digits);
        tProperty.editable = SoapService.SoapDataToBool(pSoapData.editable);
        tProperty.intervals = Interval.FromSoapArray(pSoapData.intervals);
        tProperty.propClass = pSoapData.propClass;
        tProperty.propName = pSoapData.propName;
        tProperty.propText = pSoapData.propText;
        tProperty.type = pSoapData.type;
        tProperty.value = PropertyValue.FromSoapNU(pSoapData.value);
        tProperty.visible = SoapService.SoapDataToBool(pSoapData.visible);
        tProperty.width = SoapService.SoapDataToInt(pSoapData.width);
        tProperty.multiLine = SoapService.SoapDataToBool(pSoapData.multiLine);
        return (tProperty);
    };
    return Property;
}());
export { Property };
var PropertyClass = /** @class */ (function () {
    function PropertyClass() {
    }
    PropertyClass.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, PropertyClass.FromSoapNU));
    };
    PropertyClass.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tClass = new PropertyClass();
        tClass.description = pSoapData.description;
        tClass.name = pSoapData.name;
        return (tClass);
    };
    return PropertyClass;
}());
export { PropertyClass };
var PropertyValue = /** @class */ (function () {
    function PropertyValue() {
    }
    PropertyValue.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, PropertyValue.FromSoapNU));
    };
    PropertyValue.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, PropertyValue.FromSoapNU));
    };
    PropertyValue.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tValue = new PropertyValue();
        tValue.largeIcon = pSoapData.largeIcon;
        tValue.smallIcon = pSoapData.smallIcon;
        tValue.surcharge = Money.FromSoap(pSoapData.surcharge);
        tValue.text = pSoapData.text;
        tValue.value = pSoapData.value;
        return (tValue);
    };
    return PropertyValue;
}());
export { PropertyValue };
var SeriesInfo = /** @class */ (function () {
    function SeriesInfo() {
    }
    SeriesInfo.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, SeriesInfo.FromSoapNU));
    };
    SeriesInfo.FromSoapNU = function (pSoapData) {
        var _a;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tInfo = new SeriesInfo();
        tInfo.seriesId = pSoapData.seriesId;
        //handle extra seriesName array wrapper
        tInfo.seriesName = DisplayText.FromSoapArray((_a = pSoapData.seriesName) === null || _a === void 0 ? void 0 : _a.text);
        return (tInfo);
    };
    return SeriesInfo;
}());
export { SeriesInfo };
var TaxCategory = /** @class */ (function () {
    function TaxCategory() {
    }
    TaxCategory.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, TaxCategory.FromSoapNU));
    };
    TaxCategory.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tCategory = new TaxCategory();
        tCategory.name = pSoapData.name;
        tCategory.identifier = pSoapData.identifier;
        tCategory.rate = SoapService.SoapDataToFloat(pSoapData.rate);
        tCategory.rateReadOnly = SoapService.SoapDataToBool(pSoapData.rateReadOnly);
        return (tCategory);
    };
    return TaxCategory;
}());
export { TaxCategory };
var TaxInfo = /** @class */ (function () {
    function TaxInfo() {
    }
    TaxInfo.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, TaxInfo.FromSoapNU));
    };
    TaxInfo.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tInfo = new TaxInfo();
        tInfo.taxCategory = pSoapData.taxCategory;
        tInfo.taxType = pSoapData.taxType;
        return (tInfo);
    };
    return TaxInfo;
}());
export { TaxInfo };
var TaxScheme = /** @class */ (function () {
    function TaxScheme() {
    }
    TaxScheme.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tScheme = new TaxScheme();
        tScheme.variantName = pSoapData.variantName;
        tScheme.taxTypes = TaxType.FromSoapArray(pSoapData.taxTypes);
        tScheme.orderedTaxes = OrderedTax.FromSoapArray(pSoapData.orderedTaxes);
        tScheme.country = pSoapData.country;
        tScheme.currency = pSoapData.currency;
        tScheme.identifier = pSoapData.identifier;
        tScheme.region = pSoapData.region;
        return (tScheme);
    };
    return TaxScheme;
}());
export { TaxScheme };
var TaxType = /** @class */ (function () {
    function TaxType() {
    }
    TaxType.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, TaxType.FromSoapNU));
    };
    TaxType.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tType = new TaxType();
        tType.abbreviation = pSoapData.abbreviation;
        tType.name = pSoapData.name;
        tType.taxCategories = TaxCategory.FromSoapArray(pSoapData.taxCategories);
        tType.identifier = pSoapData.identifier;
        tType.rateUnit = pSoapData.rateUnit;
        return (tType);
    };
    return TaxType;
}());
export { TaxType };
var TaxSchemeDescription = /** @class */ (function () {
    function TaxSchemeDescription() {
    }
    TaxSchemeDescription.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, TaxSchemeDescription.FromSoapNU));
    };
    TaxSchemeDescription.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tDesc = new TaxSchemeDescription();
        tDesc.variantName = pSoapData.variantName;
        tDesc.country = pSoapData.country;
        tDesc.identifier = pSoapData.identifier;
        tDesc.region = pSoapData.region;
        return (tDesc);
    };
    return TaxSchemeDescription;
}());
export { TaxSchemeDescription };
var TMColumnDef = /** @class */ (function () {
    function TMColumnDef() {
    }
    TMColumnDef.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, TMColumnDef.FromSoapNU));
    };
    TMColumnDef.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tColumn = new TMColumnDef();
        tColumn.displayName = pSoapData.displayName;
        tColumn.columnId = pSoapData.columnId;
        return (tColumn);
    };
    return TMColumnDef;
}());
export { TMColumnDef };
var TMRow = /** @class */ (function () {
    function TMRow() {
    }
    TMRow.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, TMRow.FromSoapNU));
    };
    TMRow.FromSoapArray = function (pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, TMRow.FromSoapNU));
    };
    TMRow.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tRow = new TMRow();
        tRow.texts = TMText.FromSoapArrayNU(pSoapData.texts);
        tRow.textId = pSoapData.textId;
        tRow.readOnly = SoapService.SoapDataToBool(pSoapData.readOnly);
        tRow.visible = SoapService.SoapDataToBool(pSoapData.visible);
        return (tRow);
    };
    return TMRow;
}());
export { TMRow };
var TMRowDef = /** @class */ (function () {
    function TMRowDef() {
    }
    TMRowDef.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, TMRowDef.FromSoapNU));
    };
    TMRowDef.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tRow = new TMRowDef();
        tRow.displayName = pSoapData.displayName;
        tRow.type = pSoapData.type;
        tRow.textId = pSoapData.textId;
        tRow.readOnly = SoapService.SoapDataToBool(pSoapData.readOnly);
        tRow.defaultVisible = SoapService.SoapDataToBool(pSoapData.defaultVisible);
        return (tRow);
    };
    return TMRowDef;
}());
export { TMRowDef };
var TMTable = /** @class */ (function () {
    function TMTable() {
    }
    TMTable.FromSoap = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        var tTable = new TMTable();
        tTable.columns = TMColumnDef.FromSoapArrayNU(pSoapData.columns);
        tTable.rows = TMRowDef.FromSoapArrayNU(pSoapData.rows);
        return (tTable);
    };
    return TMTable;
}());
export { TMTable };
var TMText = /** @class */ (function () {
    function TMText() {
    }
    TMText.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, TMText.FromSoapNU));
    };
    TMText.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tText = new TMText();
        tText.text = pSoapData.text;
        tText.language = pSoapData.language;
        return (tText);
    };
    return TMText;
}());
export { TMText };
var UpdateBasketArticleResult = /** @class */ (function () {
    function UpdateBasketArticleResult() {
    }
    UpdateBasketArticleResult.FromSoapArrayNU = function (pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, UpdateBasketArticleResult.FromSoapNU));
    };
    UpdateBasketArticleResult.FromSoapNU = function (pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        var tResult = new UpdateBasketArticleResult();
        tResult.itemId = pSoapData.itemId;
        tResult.updateState = pSoapData.updateState;
        return (tResult);
    };
    return UpdateBasketArticleResult;
}());
export { UpdateBasketArticleResult };
